<template>
  <div class="bdsharebuttonbox" data-tag="share_1" style="display:inline-block;">
    <!-- <a class="bds_mshare" data-cmd="mshare"></a>
    <a class="bds_qzone" data-cmd="qzone" href="#"></a>
    <a class="bds_tsina" data-cmd="tsina"></a>
    <a class="bds_baidu" data-cmd="baidu"></a>
    <a class="bds_renren" data-cmd="renren"></a>
    <a class="bds_tqq" data-cmd="tqq"></a>
    <a class="bds_more" data-cmd="more">更多</a>
    <a class="bds_count" data-cmd="count"></a> -->
    <a class="bds_weixin" data-cmd="weixin"></a>
    <!-- <a class="bds_sqq" data-cmd="sqq"></a>
    <a class="bds_tsina" data-cmd="tsina"></a> -->
  </div>
</template>

<script>
export default {
  name: 'share',
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          common: {
            bdText: '自定义分享内容',
            bdDesc: '自定义分享摘要',
            bdUrl: '自定义分享url地址',
            bdPic: '自定义分享图片'
          },
          share: [
            {
              bdSize: 16
            }
          ],
          slide: [
            {
              bdImg: 0,
              bdPos: 'right',
              bdTop: 100
            }
          ],
          image: [
            {
              viewType: 'list',
              viewPos: 'top',
              viewColor: 'black',
              viewSize: '16',
              viewList: ['qzone', 'tsina', 'huaban', 'tqq', 'renren']
            }
          ],
          selectShare: [
            {
              bdselectMiniList: ['qzone', 'tqq', 'kaixin001', 'bdxc', 'tqf']
            }
          ]
        }
      }
    }
  },
  data() {
    return {}
  },
  beforeCreate() {
    window._bd_share_main = ''
  },
  mounted() {
    this.$nextTick(() => {
      this.initShare()
    })
  },
  methods: {
    initShare() {
      window._bd_share_config = this.config
      let s = document.createElement('script')
      s.id = 'share'
      s.type = 'text/javaScript'
      let path = '/static/api/js/share.js?cdnversion=' + ~(-new Date() / 36e5)
      s.src = path
      document.body.appendChild(s)
      if (window._bd_share_main) {
        window._bd_share_main.init()
      }
    }
  }
}
</script>

<style scoped>
</style>
